import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import Card from '../components/Card';

const Pricing: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-r from-primary to-blue-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Pricing Plans</h1>
          <p className="text-xl text-blue-100">Affordable solutions for job seekers and businesses</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-secondary mb-4">For Job Seekers</h2>
            <p className="text-gray-600">Professional services to boost your career</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            <Card>
              <div className="text-center">
                <i className="fas fa-file-alt text-primary text-4xl mb-4"></i>
                <h3 className="text-xl font-semibold mb-2">CV Review</h3>
                <div className="text-3xl font-bold text-primary mb-4">$10-30</div>
                <p className="text-sm text-gray-600 mb-6">Professional CV optimization and feedback</p>
                <ul className="text-sm text-gray-600 space-y-2 mb-6">
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Expert review</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Detailed feedback</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>ATS optimization</li>
                </ul>
                <Link to="/services">
                  <Button variant="primary" size="sm" fullWidth>Get Started</Button>
                </Link>
              </div>
            </Card>

            <Card>
              <div className="text-center">
                <i className="fas fa-edit text-primary text-4xl mb-4"></i>
                <h3 className="text-xl font-semibold mb-2">Application Help</h3>
                <div className="text-3xl font-bold text-primary mb-4">$15-40</div>
                <p className="text-sm text-gray-600 mb-6">Expert assistance with job applications</p>
                <ul className="text-sm text-gray-600 space-y-2 mb-6">
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Cover letter writing</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Application review</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Submission support</li>
                </ul>
                <Link to="/services">
                  <Button variant="primary" size="sm" fullWidth>Get Started</Button>
                </Link>
              </div>
            </Card>

            <Card>
              <div className="text-center">
                <i className="fas fa-comments text-primary text-4xl mb-4"></i>
                <h3 className="text-xl font-semibold mb-2">Interview Prep</h3>
                <div className="text-3xl font-bold text-primary mb-4">$25-50</div>
                <p className="text-sm text-gray-600 mb-6">Mock interviews and preparation</p>
                <ul className="text-sm text-gray-600 space-y-2 mb-6">
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Mock interviews</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Feedback session</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Tips & strategies</li>
                </ul>
                <Link to="/services">
                  <Button variant="primary" size="sm" fullWidth>Get Started</Button>
                </Link>
              </div>
            </Card>

            <Card>
              <div className="text-center">
                <i className="fas fa-chart-line text-primary text-4xl mb-4"></i>
                <h3 className="text-xl font-semibold mb-2">Career Consultation</h3>
                <div className="text-3xl font-bold text-primary mb-4">$30-100</div>
                <p className="text-sm text-gray-600 mb-6">One-on-one career guidance</p>
                <ul className="text-sm text-gray-600 space-y-2 mb-6">
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Career planning</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Skills assessment</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Growth roadmap</li>
                </ul>
                <Link to="/services">
                  <Button variant="primary" size="sm" fullWidth>Get Started</Button>
                </Link>
              </div>
            </Card>
          </div>

          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-secondary mb-4">For Businesses</h2>
            <p className="text-gray-600">Find the right talent efficiently</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card>
              <div className="text-center">
                <h3 className="text-2xl font-bold mb-2">Basic</h3>
                <div className="text-4xl font-bold text-primary mb-4">$50<span className="text-lg text-gray-600">/mo</span></div>
                <p className="text-gray-600 mb-6">Perfect for small businesses</p>
                <ul className="text-left text-sm text-gray-600 space-y-3 mb-8">
                  <li><i className="fas fa-check text-green-600 mr-2"></i>5 job posts per month</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Basic analytics</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Email support</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>30-day job visibility</li>
                </ul>
                <Link to="/register">
                  <Button variant="outline" fullWidth>Get Started</Button>
                </Link>
              </div>
            </Card>

            <Card className="border-2 border-primary">
              <div className="text-center">
                <span className="bg-primary text-white text-xs px-3 py-1 rounded-full">POPULAR</span>
                <h3 className="text-2xl font-bold mb-2 mt-4">Pro</h3>
                <div className="text-4xl font-bold text-primary mb-4">$150<span className="text-lg text-gray-600">/mo</span></div>
                <p className="text-gray-600 mb-6">For growing companies</p>
                <ul className="text-left text-sm text-gray-600 space-y-3 mb-8">
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Unlimited job posts</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Advanced analytics</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Priority support</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>60-day job visibility</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Featured listings</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Verification badge</li>
                </ul>
                <Link to="/register">
                  <Button variant="primary" fullWidth>Get Started</Button>
                </Link>
              </div>
            </Card>

            <Card>
              <div className="text-center">
                <h3 className="text-2xl font-bold mb-2">Enterprise</h3>
                <div className="text-4xl font-bold text-primary mb-4">$500+<span className="text-lg text-gray-600">/mo</span></div>
                <p className="text-gray-600 mb-6">For large organizations</p>
                <ul className="text-left text-sm text-gray-600 space-y-3 mb-8">
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Everything in Pro</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Dedicated support</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>API access</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Custom branding</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Bulk operations</li>
                  <li><i className="fas fa-check text-green-600 mr-2"></i>Custom reports</li>
                </ul>
                <Link to="/register">
                  <Button variant="outline" fullWidth>Contact Sales</Button>
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-secondary text-center mb-12">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-lg mb-2">How do I pay for services?</h3>
              <p className="text-gray-600">We accept mobile money, credit cards, and bank transfers through our secure payment gateway.</p>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-2">Can I cancel my subscription?</h3>
              <p className="text-gray-600">Yes, you can cancel anytime. Your subscription will remain active until the end of the billing period.</p>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-2">Do you offer refunds?</h3>
              <p className="text-gray-600">We offer refunds within 7 days if you're not satisfied with our services.</p>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-2">Is there a free trial?</h3>
              <p className="text-gray-600">Yes, businesses get a 14-day free trial with the Basic plan. No credit card required.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
